import React from "react";
import styles from "./Header.module.scss";
import Logo from "../../assets/icons/Logo";
import AppstoreIcon from "../../assets/icons/header/AppstoreIcon";
import GooglePlayIcon from "../../assets/icons/header/GooglePlayIcon";
import EditIcon from "../../assets/icons/header/EditIcon";
import BellIcon from "../../assets/icons/header/BellIcon";
import LanguageSwitcher from "./LanguageSwitcher";
import TextLogo from "../../assets/icons/TextLogo";
import ThemeIcon from "../../assets/icons/ThemeIcon";
import { useNotification } from "../../contexts/NotificationToast";
import { useTheme } from "../../contexts/ThemeContext";

const Header = () => {
  const { theme, toggleTheme } = useTheme();
  const { showNotification } = useNotification();

  const showSucToast = () => {
    showNotification("Notification example", 200);
  };
  const showErrorToast = () => {
    showNotification("Notification example", 400);
  };

  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <Logo theme={theme} />
        <TextLogo theme={theme} />
      </div>
      <div className={styles.headerRight}>
        <div className={styles.services}>
          <button className={styles.servicesButton} onClick={showErrorToast}>
            <AppstoreIcon theme={theme} />
          </button>
          <button
            className={styles.servicesButton}
            onClick={() => showSucToast()}
          >
            <GooglePlayIcon />
          </button>
        </div>
        <div className={styles.settings}>
          <button className={styles.servicesButton}>
            <EditIcon theme={theme} />
          </button>
          <button className={styles.servicesButton}>
            <BellIcon theme={theme} />
          </button>
          <LanguageSwitcher />
          <button className={styles.servicesButton} onClick={toggleTheme}>
            <ThemeIcon theme={theme} />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
